export const useConfirmationModal = ({
  isSubmitted,
  setIsSubmitted,
  setIsConfirmationModalOpen,
  isConfirmationModalOpen,
}: {
  isSubmitted: boolean;
  setIsSubmitted: (isSubmitted: boolean) => void;
  setIsConfirmationModalOpen: (isConfirmationModalOpen: boolean) => void;
  isConfirmationModalOpen: boolean;
}) => {
  const handleClose = () => {
    if (isSubmitted) {
      setIsSubmitted(false);
    }

    setIsConfirmationModalOpen(false);
  };

  const onConfirmation = () => {
    setIsConfirmationModalOpen(false);
  };

  const confirmLabel = isSubmitted ? "Save" : "Go Back";
  const leaveLabel = isSubmitted ? "Cancel" : "Discard";
  const confirmTitle = isSubmitted
    ? "Are you sure you want to save this model?"
    : "Are you sure you want to close this model?";
  const confirmDescription = isSubmitted
    ? "You have some parameters that are not saved. If you save, these parameters will be lost."
    : "You have unsaved changes. If you leave, all changes will be lost.";

  return {
    isConfirmationModalOpen,
    setIsConfirmationModalOpen,
    onConfirmation,
    confirmLabel,
    leaveLabel,
    confirmTitle,
    handleClose,
    confirmDescription,
  };
};
